var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 13.25C38.258 13.25 38.9941 13.1563 39.6974 12.9798C40.9644 15.9991 43.8302 18.1816 47.2356 18.468C47.7346 20.3953 48 22.4167 48 24.5C48 37.7548 37.2548 48.5 24 48.5C10.7452 48.5 0 37.7548 0 24.5C0 11.2452 10.7452 0.5 24 0.5C25.7462 0.5 27.4488 0.686488 29.0891 1.04063C28.7085 2.0375 28.5 3.1194 28.5 4.25C28.5 9.22056 32.5294 13.25 37.5 13.25ZM18.375 38.75C21.0674 38.75 23.25 36.5674 23.25 33.875C23.25 31.1826 21.0674 29 18.375 29C15.6826 29 13.5 31.1826 13.5 33.875C13.5 36.5674 15.6826 38.75 18.375 38.75ZM39 27.5C39 30.3995 36.6495 32.75 33.75 32.75C30.8505 32.75 28.5 30.3995 28.5 27.5C28.5 24.6005 30.8505 22.25 33.75 22.25C36.6495 22.25 39 24.6005 39 27.5ZM17.25 23C20.5637 23 23.25 20.3137 23.25 17C23.25 13.6863 20.5637 11 17.25 11C13.9363 11 11.25 13.6863 11.25 17C11.25 20.3137 13.9363 23 17.25 23Z",
    fill: "#F7F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookie);
export default __webpack_public_path__ + "static/media/Cookie.f3bc7b728d4c32728786450815f1ebf0.svg";
export { ForwardRef as ReactComponent };